"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tooltip = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hooks = require("../../../hooks");
var _ClickOutside = require("../../../hooks/ClickOutside");
var _Icon = require("../Icons/PetSure/Icon");
var _EdgeProximityDetect = require("../../../hooks/EdgeProximityDetect");
require("./tooltip.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Tooltip = _ref => {
  let {
    triggerId,
    icon = 'info',
    customCssClass,
    containsBlockElements = false,
    children,
    customTrackingData,
    customTrackingEvents
  } = _ref;
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const tooltipElement = (0, _react.useRef)(null);
  const triggerElement = (0, _react.useRef)(null);
  const contentElement = (0, _react.useRef)(null);
  const iconIsElement = typeof icon !== 'string';
  (0, _ClickOutside.useOnClickOutside)(tooltipElement, () => setIsOpen(false));
  (0, _EdgeProximityDetect.useOnEdgeProximityDetect)({
    triggerRef: triggerElement,
    wrapperRef: tooltipElement,
    contentRef: contentElement,
    requiresRecalc: isOpen
  });
  (0, _hooks.useTracking)({
    elementRef: triggerElement,
    trackingProps: {
      label: 'Toggle tooltip open state',
      tooltipIsOpen: isOpen
    },
    customTrackingData,
    customTrackingEvents
  });
  if (containsBlockElements) {
    return /*#__PURE__*/_react.default.createElement("div", {
      role: "tooltip",
      ref: tooltipElement,
      className: "petSure_tooltip petSure_tooltip_block ".concat(isOpen ? 'isOpen' : '', " ").concat(customCssClass || '')
    }, /*#__PURE__*/_react.default.createElement("button", _extends({
      "aria-label": "Toggle tooltip open state",
      ref: triggerElement,
      type: "button",
      className: "button icon_only"
    }, triggerId ? {
      id: triggerId,
      'aria-describedby': "".concat(triggerId, "_content")
    } : {}), iconIsElement ? icon : /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      icon: icon
    })), /*#__PURE__*/_react.default.createElement("div", _extends({
      ref: contentElement,
      className: "content"
    }, triggerId ? {
      id: "".concat(triggerId, "_content")
    } : {}), children));
  }
  return /*#__PURE__*/_react.default.createElement("span", {
    ref: tooltipElement,
    className: "petSure_tooltip ".concat(isOpen ? 'isOpen' : '', " ").concat(customCssClass || '')
  }, /*#__PURE__*/_react.default.createElement("button", _extends({
    ref: triggerElement,
    type: "button",
    className: "button icon_only",
    onClick: () => setIsOpen(!isOpen),
    onFocus: () => setIsOpen(!isOpen),
    onBlur: () => setIsOpen(!isOpen),
    onMouseLeave: () => setIsOpen(false)
  }, triggerId ? {
    id: triggerId
  } : {}), iconIsElement ? icon : /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: icon
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, children)), /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": true,
    role: "presentation",
    ref: contentElement,
    className: "content"
  }, children));
};
exports.Tooltip = Tooltip;
Tooltip.propTypes = {
  triggerId: _propTypes.default.string,
  icon: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  customCssClass: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  containsBlockElements: _propTypes.default.bool,
  // eslint-disable-next-line react/forbid-prop-types
  customTrackingData: _propTypes.default.any,
  customTrackingEvents: _propTypes.default.arrayOf(_propTypes.default.string)
};
var _default = exports.default = Tooltip;